const audioConfig = {
  label: 'Audio',
  resourceEndpoint: 'audios',
  listMetadata: ['sort_order',
                 'title',
                 'featured',
                 'topics',
                 'categories',
                 'release_date',
                 'tags',
                 'actions'],
  searchKeys: ['title', 'author'],
  keepListMetadataOrder: true,
  detailsMetadata: [
    { name: 'title', label: 'Title'},
    { name: 'author', label: 'Author', validations:
      [
        {type: 'required', params: ['Required']}
      ]
    },
    { name: 'description', label: 'Description' },
    { name: 'web_description', label: 'Description' },
    { name: 'audio_url', label: 'Audio URL', validations:
      [
        {type: 'required', params: ['Required']}
      ]
    },
    { name: 'image_url', label: 'Image URL'},
    { name: 'release_date', label: 'Release Date', format: "DD-MMM-YYYY"},
    {
      name: "cta_type",
      label: ""
    },
    {
      name: "action_bar_text",
      label: "Call to Action Text",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "action_bar_text_enterprise",
      label: "Launch Business Call to Action Text",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "action_bar_url",
      label: "Call to Action URL",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "enterprise_app",
      label: "Which Business?",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "cta",
      label: "Call to Action Name List",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return relativeField.value === "Preset CTA";
          },
        },
      ],
    },
    { name: 'sort_order', label: 'Sort Order'},
    { name: 'featured', label: 'Featured'},
    { name: 'topics', label: 'Topics/Listings'},
    { name: 'categories', label: 'Categories' },
    { name: 'tags', label: 'Tags'},
  ],
  formLayout: {
    columns: [
      ["title", "author", "description", "image_url", "audio_url", "release_date",],
      [
        "cta_type",
        "action_bar_text",
        "action_bar_text_enterprise",
        "action_bar_url",
        "enterprise_app",
        "cta",
        "featured",
        "topics",
        "categories",
        "sort_order",
        "tags",
      ],
    ],
  },
}

export default audioConfig
